import { Banner } from 'component/Banner/Banner'
import { Button } from 'component/Button'
import { Divider, Space } from 'component/Space'
import { Gap } from 'component/Space/Gap'
import { Typo } from 'component/Typo'
import { openMeasurementsBanner } from 'feature/measurements/store'
import { findFullProfile } from 'feature/measurements/util'
import { sizes_banner } from 'feature/sizes/store'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { formatSize } from 'type/size'
import { formatPercent } from 'util/number'
import { renderArray } from 'util/render'

export const SizesBanner = observer(() => {
  const banner = sizes_banner.it
  const { inference, sizes } = banner
  const profile = findFullProfile(inference)

  const onEdit = useLatestCallback(async () => {
    if (!profile) return
    sizes_banner.close()
    openMeasurementsBanner(profile, inference)
  })

  const onCancel = useLatestCallback(async () => {
    sizes_banner.close()
  })

  return <Banner title={i18n('RecommendedSizes')} onCancel={onCancel}>
    {renderArray(sizes, size => (
      <Space gap={16} height={40} opposite>
        <Typo size={14}>
          {formatSize(size)}
        </Typo>
        {size.percent && <Typo size={12} secondary>
          {i18n('FitProbability')} {formatPercent(size.percent)}
        </Typo>}
      </Space>
    ), () => (
      <Divider />
    ))}
    <Gap height={16} />
    {profile && <Button large dashed wide action={onEdit} icon={<Icon size={16} name="edit" />}>
      <Typo size={14} medium upper>
        {i18n('EditMyMeasurements')}
      </Typo>
    </Button>}
    {profile && <Gap height={12} />}
    <Button large primary wide action={onCancel}>
      <Typo size={14} medium upper>
        {i18n('GotIt')}
      </Typo>
    </Button>
  </Banner>
})
